import React from 'react';
import { policyUrl, useLang, useT } from '@repo/common';
import { ReactComponent as ExternalArrow } from '@repo/common/assets/icons/16px/icon_16px_navigation-diagonal.svg';

const linkClass = 'text-text-primary underline cursor-pointer';

const BottomText = () => {
  const t = useT();
  const { lang } = useLang();
  return (
    <div className='px-6 py-4 rounded-lg bg-grayscale-gray02 text-text-secondary typo-b12 whitespace-pre-line'>
      <p className='mb-3'>
        {t(
          'Your resume is saved as submitted. Later edits to your resume will not change this application. To change your submission, withdraw and apply again while the job is open.',
          '지원 시점의 이력서가 보관되며, 이후 원본을 수정해도 제출본은 변경되지 않습니다. 제출 내용을 변경하려면 지원 취소 후 수정하여 모집 중인 공고에 재지원해 주세요.',
        )}
      </p>
      {t(
        `The submitted documents will be made available to the employer as follows:
• In case of final acceptance: up to 90 days after the official start date.
• In case of non-selection: access will be terminated immediately upon completion of the recruitment process.
By sending the request you confirm that you accept our `,
        `제출된 서류는 다음과 같이 채용 기업에 제공됩니다:
• 최종 합격 시: 공식 입사일로부터 최대 90일까지 제공됩니다.
• 불합격 시: 채용 절차 종료 즉시 열람이 종료됩니다.
지원서를 제출하시면 `,
      )}
      <a
        href={policyUrl('terms', lang)}
        target='_blank'
        rel='noopener noreferrer'
        className={linkClass}
      >
        {t('Terms of Service', '이용약관')}
      </a>
      {t(' and ', ' 및 ')}
      <a
        href={policyUrl('privacy', lang)}
        target='_blank'
        rel='noopener noreferrer'
        className={linkClass}
      >
        {t('Privacy Policy', '개인정보 처리방침')}
      </a>
      {t(
        `, and you acknowledge and consent to the submission and sharing of your documents for recruitment purposes.
If you do not agree, you will not be able to proceed with the application.`,
        `에 동의하는 것으로 간주되며, 채용 목적을 위한 서류 제출 및 공유에 동의하게 됩니다.
동의하지 않으실 경우 지원을 진행할 수 없습니다.`,
      )}
      <div className='mt-4 border-t border-grayscale-gray03 pt-4 whitespace-normal'>
        <p>
          {t(
            "Before you apply, check the Ministry of Employment and Labor's public list of employers with unpaid wages.",
            '지원 전에 고용노동부가 공개한 체불사업주 명단을 확인해 보세요.',
          )}
        </p>
        <a
          href='https://www.moel.go.kr/info/defaulter/defaulterList.do'
          target='_blank'
          rel='noopener noreferrer'
          className='mt-2 inline-flex items-center gap-1 text-text-primary underline underline-offset-2 hover:text-green-deep03 focus-visible:rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-deep03'
        >
          {t('Check the unpaid wages list', '체불사업주 명단 확인하기')}
          <ExternalArrow className='size-4 shrink-0' aria-hidden='true' />
          <span className='sr-only'>
            {t(' (opens in a new tab)', ' (새 탭에서 열림)')}
          </span>
        </a>
      </div>
    </div>
  );
};

export default BottomText;
